export default __webpack_public_path__ + "static/media/office_web-sm@2x.76f79ce0.jpg";